<div class="container">
  <section class="requisites">
    <div class="country-breadcrumbs">
      <a href="" class="country-breadcrumb">
        BusyFly /
      </a>
      <div class="country-breadcrumb">
        Реквизиты партнеров
      </div>
    </div>
    <app-requisites
    [requisites]="requisites">
    </app-requisites>
  </section>
</div>
